var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("category-no-results", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.freeSelected && _vm.freeIconCount == 0,
            expression: "freeSelected && freeIconCount == 0",
          },
        ],
        attrs: {
          "category-label": _vm.categoryLabel,
          "selected-style": _vm.selectedStyle,
          "selected-family": _vm.selectedFamily,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "compact icon-listing margin-top-lg margin-bottom-4xl",
          attrs: {
            id: `icon-results-${_vm.sluggifyStyle(_vm.selectedStyle)}`,
            role: "tabpanel",
            "aria-labelledby": `tab-${_vm.sluggifyStyle(_vm.selectedStyle)}`,
          },
        },
        _vm._l(_vm.icons, function (item) {
          return _c("icon", {
            key: item.objectID,
            attrs: {
              icon: item,
              "icon-style": item.style,
              "is-pro-user": _vm.isProUser,
              "new-tag-enabled": true,
              "selected-icon-id": _vm.selectedIconId,
              "selected-style": _vm.selectedStyle,
              version: _vm.version,
              "results-view": "compact",
            },
            on: { toggleIcon: _vm.toggleIcon },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }